import { type CarrierInfo, isObject, useApiPostDealTrackerV1CarriersRetrieve } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type CarrierAutocompleteProps = Omit<AutocompleteFieldProps<CarrierInfo>, 'options' | 'defaultValue'> & {
  defaultValue?: CarrierInfo['id'];
};

export const CarrierAutocomplete = ({ defaultValue, ...props }: CarrierAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiPostDealTrackerV1CarriersRetrieve({
    page_size: 100000,
    search: query, // Large page size to get all carriers
  });

  return (
    <AutocompleteField<CarrierInfo>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => {
        if (isObject(item) && item?.name) {
          return item.name;
        }
        return '';
      }}
      valueField="id"
      data-testid="carrier-autocomplete"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...props}
    />
  );
};
